import React from "react";

import Image from "next/image";

import ChoiceIcon from "public/images/icons/home/icon-choice.svg";
import FlowIcon from "public/images/icons/home/icon-flow.svg";
import NetworkIcon from "public/images/icons/home/icon-network.svg";

import Heading from "components/heading";
import HeroSection from "components/hero-section";

import { sectionIds } from "./section-ids";

const sections = [
  {
    title: "Choice",
    description:
      'Keep your lenders, your CRM, your design tool. Enerflo connects them — it doesn\'t completely replace them. This is why companies that "tried a platform before" can trust this.',
    figure: ChoiceIcon,
  },
  {
    title: "Flow",
    description:
      "One system. One login. Every deal from design & proposal to PTO without copy-pasting, tab switching, or chasing missing data across disconnected apps.",
    figure: FlowIcon,
  },
  {
    title: "Network",
    description:
      "Every financier, installer, sales org, and distributor that connects to the OS makes it more valuable for everyone already on it. Competitors can copy features. They can't copy a network.",
    figure: NetworkIcon,
  },
];

const title = "How Enerflo's Solar Operating System (OS) Works";

const HowOSWorks = () => {
  return (
    <div className="bg-navy">
      <HeroSection title={title} id={sectionIds.howOsWorks}>
        <HeroSection.Content className="space-y-10">
          <header className="text-center mb-12">
            <HeroSection.Tagline className="text-amber-500 mb-8">{title}</HeroSection.Tagline>
            <Heading tag="h2" className="mb-6 max-w-4xl mx-auto">
              <span className="text-primary">It’s not another tool.</span>{" "}
              <span className="text-white">It’s the infrastructure that connects them.</span>
            </Heading>
            <p className="text-lg text-gray-200 max-w-5xl mx-auto">
              Every maturing industry builds this infrastructure layer. Healthcare built EHR systems. Real estate built
              MLS. Finance built Bloomberg. Residential solar has been running on duct tape — until now.
            </p>
          </header>

          <div className="flex flex-col gap-4 md:gap-8 md:flex-row">
            {sections.map(section => (
              <div key={section.title} className="bg-white rounded-xl p-4 flex flex-1 flex-col lg:p-6">
                <div className="flex items-center justify-center md:justify-start gap-4">
                  <figure className="flex items-center justify-center rounded-lg border border-primary text-primary p-1 bg-primary/20 h-8 w-8 md:h-10 md:w-10">
                    <Image src={section.figure} alt={`Enerflo Operating System: ${section.title} Icon`} />
                  </figure>
                  <Heading tag="h3" size="h5" className="inline-block min-w-[72px] text-left">
                    {section.title}
                  </Heading>
                </div>
                <p className="mt-4">{section.description}</p>
              </div>
            ))}
          </div>
        </HeroSection.Content>
      </HeroSection>
    </div>
  );
};

export default HowOSWorks;
